import React from 'react';

const Checkout = () => {
    return (
        <div>
            <h1>dfcasgvdhsbxjsbxjs</h1>
        </div>
    );
};

export default Checkout;